import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { PushRowBlockConfig } from '@front-platform/content-builder';
import { pushRowBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
export interface PushRowBlockRuntimeConfig {
  'pushes'?: any[];
}

export type PushRowBlockConfigInput = Partial<
  Omit<PushRowBlockConfig, keyof PushRowBlockRuntimeConfig> & PushRowBlockRuntimeConfig
>;
export type PushRowBlockResolvedConfig = Omit<PushRowBlockConfig, keyof PushRowBlockRuntimeConfig> &
  Partial<PushRowBlockRuntimeConfig>;
export interface PushRowBlockContract extends ConfigComponentContract<
  PushRowBlockConfigInput,
  PushRowBlockResolvedConfig
> {}

@Component({
  selector: 'app-push-row-block',
  templateUrl: './push-row-block.component.html',
  standalone: false,
})
export class PushRowBlockComponent implements PushRowBlockContract {
  readonly config = input<PushRowBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<PushRowBlockConfig, PushRowBlockRuntimeConfig>(
    pushRowBlockResolveConfig,
    () => ({ config: this.config() }),
  );
  get pushes(): any[] {
    return this.resolvedConfig()['pushes'] as unknown as any[];
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(PushRowBlockComponent, { 'keyAliases': {} });
